<!-- eslint-disable -->
<template>
    <div class="minimal-auth-wrapper">
        <div class="auth-container">
            <!-- Logo Section -->
            <div class="logo-section" v-if="app.logo">
                <b-img :src="app.logo" alt="Logo" class="brand-logo" />
            </div>

            <!-- Main Card -->
            <div class="login-card">
                <!-- Header -->
                <div class="login-header text-center">
                    <h1 class="login-title">¡Enlace enviado! 📧</h1>
                </div>

                <!-- Success Alert -->
                <div class="success-alert">
                    <div class="alert-icon">
                        <feather-icon icon="MailIcon" size="32" />
                    </div>
                    <div class="alert-content">
                        <strong>Revisa tu email</strong>
                        <p class="text-muted mb-0">Enviado a:</p>
                        <strong class="email-text">{{ userEmail }}</strong>
                        <p class="expiry-text">
                            Haz clic en el enlace para acceder (expira en 15
                            minutos)
                        </p>
                    </div>
                </div>

                <!-- Action Buttons -->
                <b-button
                    variant="primary"
                    block
                    class="submit-btn mb-3"
                    :disabled="isResending || countdown > 0"
                    @click="resendMagicLink"
                >
                    <feather-icon icon="RefreshCwIcon" class="mr-1" />
                    {{ resendButtonText }}
                </b-button>

                <b-button
                    variant="outline-secondary"
                    block
                    class="back-btn"
                    @click="goToLogin"
                >
                    <feather-icon icon="ArrowLeftIcon" class="mr-1" />
                    Volver al login
                </b-button>

                <!-- Help Text -->
                <div class="info-text">
                    <feather-icon icon="HelpCircleIcon" size="16" />
                    <span>¿No lo ves? Revisa spam o reenvía el enlace</span>
                </div>
            </div>

            <!-- Payment Methods -->
            <div class="payment-methods">
                <p class="payment-label">Métodos de pago</p>
                <div class="payment-images">
                    <b-img
                        :src="imgFooter"
                        alt="Tarjetas"
                        class="payment-img"
                    />
                    <b-img
                        :src="imgPayPal"
                        alt="PayPal"
                        class="payment-img-paypal"
                    />
                </div>
            </div>

            <!-- Footer -->
            <div class="page-footer">
                <feather-icon icon="LockIcon" size="14" />
                <span>Conexión segura</span>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
    BAlert,
    BButton,
    BCard,
    BCardBody,
    BCardText,
    BCardTitle,
    BCol,
    BImg,
    BLink,
    BRow,
} from "bootstrap-vue";

export default {
    components: {
        BRow,
        BCol,
        BButton,
        BCard,
        BCardBody,
        BCardTitle,
        BLink,
        BCardText,
        BAlert,
        ToastificationContent,
        BImg,
    },
    data() {
        return {
            userEmail: "",
            isResending: false,
            countdown: 0,
            countdownInterval: null,
            app: {
                banner: "",
                nombre: "",
                logo: "",
            },
            imgFooter: require("@/assets/images/logo/footer-card.png"),
            imgPayPal: require("@/assets/images/logo/paypal.png"),
        };
    },
    computed: {
        resendButtonText() {
            if (this.isResending) {
                return "Reenviando...";
            }
            if (this.countdown > 0) {
                return `Reenviar en ${this.countdown}s`;
            }

            return "Reenviar enlace";
        },
    },
    created() {
        this.$http
            .get("/get-env")
            .then((response) => {
                this.app.banner = response.data.data.app_banner;
                this.app.name = response.data.data.app_name;
                this.app.logo = response.data.data.app_logo;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    mounted() {
        this.userEmail = this.$route.params.email || "";
        this.startResendCountdown();
    },
    beforeDestroy() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
        }
    },
    methods: {
        startResendCountdown() {
            this.countdown = 60; // 60 segundos de espera para reenviar
            this.countdownInterval = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    clearInterval(this.countdownInterval);
                }
            }, 1000);
        },

        async resendMagicLink() {
            if (!this.userEmail) {
                this.$swal({
                    title: "Error",
                    text: "Email no encontrado. Por favor vuelva al login.",
                    icon: "error",
                });

                return;
            }

            this.isResending = true;

            try {
                await useJwt.sendMagicLink(this.userEmail);

                this.showToast(
                    "Enlace reenviado correctamente",
                    "success",
                    "MailIcon"
                );

                // Reiniciar contador
                this.startResendCountdown();
            } catch (error) {
                this.$swal({
                    title: "Error",
                    text:
                        error.response?.data?.message ||
                        "Error reenviando el enlace",
                    icon: "error",
                });
            } finally {
                this.isResending = false;
            }
        },

        goToLogin() {
            this.$router.push({ name: "auth-login" });
        },

        showToast(message, variant, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: message,
                    variant,
                    icon,
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/pages/page-auth.scss";

// Minimal Auth Wrapper
.minimal-auth-wrapper {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafbfc;
    padding: 2rem;
}

// Auth Container
.auth-container {
    width: 100%;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

// Logo Section
.logo-section {
    margin-bottom: 3rem;

    .brand-logo {
        max-width: 180px;
        max-height: 180px;
        display: block;
    }
}

// Login Card
.login-card {
    width: 100%;
    background: #ffffff;
    border: 1px solid #e1e4e8;
    border-radius: 8px;
    padding: 2rem;
    margin-bottom: 2rem;
}

// Login Header
.login-header {
    margin-bottom: 2rem;

    .login-title {
        font-size: 1.5rem;
        font-weight: 600;
        color: #24292e;
        margin: 0;
        letter-spacing: -0.02em;
    }
}

// Success Alert
.success-alert {
    background-color: #dcffe4;
    border: 1px solid #34d058;
    border-radius: 6px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
    text-align: center;

    .alert-icon {
        margin-bottom: 0.75rem;

        svg {
            color: #28a745;
        }
    }

    .alert-content {
        strong {
            color: #24292e;
            display: block;
        }

        .text-muted {
            font-size: 0.875rem;
            margin-top: 0.5rem;
        }

        .email-text {
            color: #0366d6;
            font-size: 0.9rem;
        }

        .expiry-text {
            font-size: 0.75rem;
            color: #586069;
            margin-top: 0.5rem;
            margin-bottom: 0;
        }
    }
}

// Submit Button
.submit-btn {
    height: 44px;
    padding: 0.625rem 1rem;
    font-size: 0.875rem;
    font-weight: 600;
    color: #ffffff !important;
    background-color: #24292e;
    border: 1px solid rgba(27, 31, 35, 0.15);
    border-radius: 6px;
    transition: background-color 0.2s ease;

    &:hover:not(:disabled) {
        background-color: #1b1f23;
        border-color: rgba(27, 31, 35, 0.15);
    }

    &:focus {
        box-shadow: 0 0 0 3px rgba(36, 41, 46, 0.1);
    }

    &:active:not(:disabled) {
        background-color: #181b1f;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

// Back Button
.back-btn {
    height: 44px;
    padding: 0.625rem 1rem;
    font-size: 0.875rem;
    font-weight: 600;
    color: #24292e;
    background-color: #fafbfc;
    border: 1px solid #d1d5da;
    border-radius: 6px;
    transition: background-color 0.2s ease;

    &:hover:not(:disabled) {
        background-color: #f3f4f6;
        border-color: #d1d5da;
    }

    &:focus {
        box-shadow: 0 0 0 3px rgba(36, 41, 46, 0.1);
    }
}

// Info Text
.info-text {
    margin-top: 1rem;
    padding: 0.75rem;
    background-color: #f6f8fa;
    border: 1px solid #e1e4e8;
    border-radius: 6px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.75rem;
    color: #586069;
    line-height: 1.4;

    svg {
        flex-shrink: 0;
        color: #0366d6;
    }
}

// Payment Methods
.payment-methods {
    width: 100%;
    padding: 1.5rem 0;
    text-align: center;

    .payment-label {
        font-size: 0.75rem;
        color: #6a737d;
        margin: 0 0 1rem 0;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        font-weight: 600;
    }

    .payment-images {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.75rem;

        .payment-img {
            max-width: 260px;
            height: auto;
            opacity: 0.7;
        }

        .payment-img-paypal {
            max-width: 80px;
            height: auto;
            opacity: 0.7;
        }
    }
}

// Page Footer
.page-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    font-size: 0.75rem;
    color: #6a737d;

    svg {
        color: #28a745;
    }
}

// Responsive Design
@media (max-width: 576px) {
    .minimal-auth-wrapper {
        padding: 1rem;
    }

    .auth-container {
        max-width: 100%;
    }

    .logo-section {
        margin-bottom: 2rem;

        .brand-logo {
            max-width: 100px;
            max-height: 100px;
        }
    }

    .login-card {
        padding: 1.5rem;
    }

    .login-header {
        margin-bottom: 1.5rem;

        .login-title {
            font-size: 1.25rem;
        }
    }

    .payment-methods {
        padding: 1rem 0;

        .payment-images {
            .payment-img {
                max-width: 220px;
            }
        }
    }
}

@media (max-width: 360px) {
    .login-card {
        padding: 1.25rem;
    }

    .payment-images {
        .payment-img {
            max-width: 200px;
        }

        .payment-img-paypal {
            max-width: 70px;
        }
    }
}
</style>
